import "bootstrap/dist/css/bootstrap.min.css";
import StatCardGrid from "../cards/StatCardGrid";
import "./AboutOverviewSection.css";
import { websitePaths } from "../../../routes/websitePaths";

const AboutUs = () => {
  const cardData = [
    {
      icon: "bi bi-award",
      title: "20+ Years of Excellence",
      description:
        "Consistent quality and technical expertise across project categories.",
      link: websitePaths.about,
    },
    {
      icon: "bi bi-houses",
      title: "Projects Completed",
      description:
        "Reliable execution for residential, commercial, and industrial sites.",
      link: websitePaths.projects.completed,
    },
    {
      icon: "bi bi-emoji-smile",
      title: "Happy Clients",
      description:
        "Long-term trust built through transparent communication and delivery.",
      link: websitePaths.reviews.videos,
    },
    {
      icon: "bi bi-shield-check",
      title: "Safety And Compliance",
      description:
        "Strict quality and safety checks throughout each project phase.",
      link: websitePaths.safetyCompliance,
    },
  ];

  return (
    <section id='about' className='mt-4 about-overview-section'>
      <div className='container'>
        <div className='row align-items-center g-4'>
          <div className='col-md-6'>
            <div className='overflow-hidden rounded-4 shadow about-image-wrap'>
              <img
                src='../images/IMG-20251110-WA0006.jpg.jpeg'
                alt='Dialin24 team at work'
                className='img-fluid about-img'
              />
            </div>
          </div>

          <div className='col-md-6'>
            <h3 className='mb-3 website-section-title'>Our Story</h3>
            <p className='mb-4 about-text'>
              Dialin24 delivers construction work with disciplined planning,
              careful execution, and clear coordination at every stage. Our
              focus stays on building spaces that are durable, functional, and
              ready for long-term use.
            </p>

            <div className='row g-3'>
              <div className='col-6'>
                <div className='p-3 h-100 about-card brand-card'>
                  <h5 className='fw-bold mb-1'>25+ Years</h5>
                  <p className='mb-0'>Combined site experience</p>
                </div>
              </div>
              <div className='col-6'>
                <div className='p-3 h-100 about-card brand-card'>
                  <h5 className='fw-bold mb-1'>Safety First</h5>
                  <p className='mb-0'>Structured checks on every site</p>
                </div>
              </div>
              <div className='col-6'>
                <div className='p-3 h-100 about-card brand-card'>
                  <h5 className='fw-bold mb-1'>Quality Assured</h5>
                  <p className='mb-0'>Reliable materials and workmanship</p>
                </div>
              </div>
              <div className='col-6'>
                <div className='p-3 h-100 about-card brand-card'>
                  <h5 className='fw-bold mb-1'>Client Satisfaction</h5>
                  <p className='mb-0'>98% happy clients</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <StatCardGrid cards={cardData} />
      </div>
    </section>
  );
};

export default AboutUs;
